'use client'

import { useMutation } from '@tanstack/react-query'

import { client } from '@/lib/api'

const PUT_TENANT_MAINTENANCE_EXIT = '/tenants/maintenance/exit'

type ExitTenantMaintenanceParams = {
  lockVersion: number
}

export function useExitTenantMaintenance() {
  return useMutation({
    mutationFn: async ({ lockVersion }: ExitTenantMaintenanceParams) => {
      const { data, error, response } = await client.PUT(PUT_TENANT_MAINTENANCE_EXIT, {
        body: {
          lockVersion,
        },
      })

      return {
        data,
        error,
        response,
      }
    },
  })
}
